import {createApp} from 'vue'
import Axios from 'axios'
import {createRouter, createWebHistory} from 'vue-router'
import mitt from 'mitt'
import {createApi, setRouter as setApiRouter} from '@/services/api'
import {appRoutes} from './router/routes'
import mainVue from './Main.vue'
import {createPinia} from 'pinia'
import {createI18n} from 'vue-i18n'

// Import theme CSS files
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/remixicon.css'
import '@/assets/css/style.css'
import '@/assets/css/header.css'
import '@/assets/css/footer.css'
import '@/assets/css/responsive.css'
import '@/assets/css/dark.css'

// Import Bootstrap JS
import 'bootstrap'

// Import GSAP
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger)

// Make GSAP available globally
window.gsap = gsap
window.ScrollTrigger = ScrollTrigger


// @ts-ignore
import {authService, setRouter as setAuthRouter} from '@/services/auth'
// @ts-ignore
import * as en from './lang/en.json'
// @ts-ignore

import {configureRouter} from './router/routerConfig'
import {hasPermissions, hasRole} from './services/acl'
import {toast} from './services/toast'

const app = createApp(mainVue)

// @ts-ignore
import Cookies from 'js-cookie'

// Get saved locale from cookie or default to 'en'
const savedLocale = Cookies.get('locale') || 'en';

const i18n = createI18n({
    locale: savedLocale,
    fallbackLocale: 'en',
    messages: {
        'en': en,
        // 'bn': bn
    },
})

const pinia = createPinia()
const router = createRouter({
    history: createWebHistory(),
    routes: appRoutes,
    scrollBehavior() {
        return {top: 0}
    }
})

setApiRouter(router)
setAuthRouter(router)

const api = createApi({
    handler: Axios,
    namespace: '/v1',
    router: router
})

// Configure router with guards
configureRouter(router, app)

app.use(i18n)
app.use(pinia)
app.use(api)
app.use(router)

app.config.globalProperties.$mitt = mitt()
app.config.globalProperties.$toast = toast
app.config.globalProperties.$goTo = function (route_name: any) {
    this.$router.push({name: route_name})
}

app.config.globalProperties.$parseValidationErrors = function (bag: any, errors: any) {
    Object.keys(errors).forEach(function (key: any) {
        const value = errors[key]
        let found = 0
        bag.map((item: { field: string; messages: string[] }) => {
            if (item.field === key) {
                found = 1
                item.messages.push(value)
            }
            return item
        })
        if (found === 0) {
            bag.push({'field': key, 'messages': value})
        }
    })
    return bag
}
app.config.globalProperties.$toBool = function (str: any) {
    return String(str).toLowerCase() == "true" || String(str) === "1" || str === 1 || str === true
}

app.config.globalProperties.$auth = {
    ...authService,
    hasRole,
    hasPermissions
}

// Load site defaults and apply theme before mounting
import { useSiteDefaultsStore } from './stores/siteDefaultsStore'

// Initialize the store and load defaults
const siteDefaultsStore = useSiteDefaultsStore()

// Load site defaults and apply theme
siteDefaultsStore.loadSiteDefaults().then(() => {
    // Update favicon from settings
    const favicon = siteDefaultsStore.getFavicon()
    if (favicon) {
        const linkElement = document.querySelector('link[rel="icon"]') as HTMLLinkElement
        if (linkElement) {
            linkElement.href = favicon
        }
    }
})

app.mount('#app')
